import api from './api'
import { Notification, ApiResponse } from '../types'

export const notificationService = {
  async getAll(unreadOnly?: boolean): Promise<Notification[]> {
    const params = unreadOnly ? '?unreadOnly=true' : ''
    const response = await api.get<ApiResponse<Notification[]>>(
      `/notifications${params}`
    )
    return response.data.data
  },

  async getByEmployeeId(employeeId: string): Promise<Notification[]> {
    const response = await api.get<ApiResponse<Notification[]>>(
      `/notifications/employee/${employeeId}`
    )
    return response.data.data
  },

  async getUnreadCount(): Promise<number> {
    const response = await api.get<ApiResponse<{ count: number }>>(
      '/notifications/unread-count'
    )
    return response.data.data.count
  },

  async markAsRead(id: string): Promise<Notification> {
    const response = await api.put<ApiResponse<Notification>>(
      `/notifications/${id}/read`
    )
    return response.data.data
  },

  async markAllAsRead(): Promise<void> {
    await api.put('/notifications/read-all')
  },
}
